import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { AddOfferUniqueStep2 } from "@/features/CouponCodes/AddOfferUniqueStep2";

const searchSchema = z.object({
  discountName: z.string().min(1),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/new/unique",
)({
  validateSearch: zodValidator(searchSchema),
  component: UniqueCouponCodeLayout,
});

function UniqueCouponCodeLayout() {
  const location = useLocation();
  const pathname = location.pathname;
  const hasChildRoute =
    pathname.endsWith("/shopify") ||
    pathname.endsWith("/foxy") ||
    pathname.endsWith("/csv");

  if (hasChildRoute) {
    return <Outlet />;
  }

  return <AddOfferUniqueStep2 />;
}
